import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import useUserSession from '@medflex/hooks/useUserSession';
import Logger from '@medflex/utils/Logger';

const useChatConnection = () => {
  const { session } = useUserSession();
  const dispatch = useDispatch();
  useEffect(() => {
    if (session && !session.expired) {
      Logger.log('[useChatConnection::session changed, connect websocket]');
      // eslint-disable-next-line no-underscore-dangle
      dispatch._chat.connect();
    }
    if (session && session.expired) {
      Logger.log('[useChatConnection::session expired, disconnect websocket]');
      // eslint-disable-next-line no-underscore-dangle
      dispatch._chat.disconnect();
    }
    // eslint-disable-next-line no-underscore-dangle
    return dispatch._chat.disconnect;
  }, [session]);
};

export default useChatConnection;
